<template>
  <v-container
    class="background black--text pb-lg-0"
    id="home-container"
    style="height: 250vh"
  >
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-row id="main-box">
      <v-col cols="12" class="col-lg-6 col-md-12 col-lg-12 mr-lg-2 px-0">
        <div class="topbar"></div>
        <v-card elevation="2" tile class="">
          <v-col
            cols="12 "
            class="col-lg-12 flex-sm-wrap flex-lg-row flex-lg-nowrap"
          >
            <!-- video goes herem make 100% in small, 50% on -->
            <div id="cardYouTube" class="links">
              <iframe
                class="py-md-0"
                date-tube
                src="https://www.youtube.com/embed/KMCbOjmZbOE"
                frameborder="2"
                allowfullscreen
              ></iframe>
            </div>

            <!-- Ist row -->
            <v-row
              cols="12"
              class="howtotext pt-lg-3 col-lg-12 justify-lg-space-around"
            >
              <!-- 1st col -->
              <v-col cols="12" class="col-lg-5 online-reports flex-lg-col">
                <!-- title width 100% -->
                <v-card-title class="title-text lg-text-width pa-0 py-lg-0"
                  >The following report types can be filed online at
                  "insertlink"</v-card-title
                >

                <v-col class="online-1 pt-0">
                  <v-card-text class="pb-0">
                    <ul>
                      <li>BURGLARY</li>
                      <li>CIVIL PROBLEM</li>
                      <li>DESTRUCTION OF PROPERTY</li>
                      <li>GRAFFITI</li>
                      <li>FRAUD/IDENTITY THEFT</li>
                      <li>LOST PROPERTY</li>
                      <li>SUSPICIOUS CIRCUMSTANCES</li>
                      <li>THEFT</li>
                      <li>TRAFFIC ACCIDENTS</li>
                      <li>TRESPASSING</li>
                      <li>VEHICLE BURGLARY</li>
                      <li>VEHICLE TAMPERING</li>
                    </ul>
                  </v-card-text>
                </v-col>
              </v-col>

              <!-- 2nd col -->
              <v-col class="col-lg-5 online-reports flex-lg-col">
                <v-card-title class="title-text lg-text-width pa-0"
                  >The following report types must be filed with an officer or
                  PSS</v-card-title
                >
                <v-col class="online-2 pt-0">
                  <v-card-text class="pb-0">
                    <ul class="pb-3">
                      <li>MISSING PERSONS</li>
                      <li>DOMESTIC VIOLENCE</li>
                      <li>STOLEN VEHICLES</li>
                      <li>CHILD CRIMES</li>
                      <li>SEX RELATED CRIMES</li>
                    </ul>
                  </v-card-text>
                  <v-card-text class="pa-0">
                    Please contact the Front Desk at
                    <a href="tel:=+17753342175">775-334-2175</a>
                    for further assistance in how to file a report regarding
                    these types of crimes.
                  </v-card-text>
                </v-col>
              </v-col>
            </v-row>
            <!-- 2nd row -->
            <v-row>
              <!-- 1st col -->
              <v-col cols="12" class="col-lg-6 py-0">
                <v-card-title class="py-0 pb-lg-3">
                  Why can’t I file this report with an officer or PSS?
                </v-card-title>
                <v-card-text>
                  Most crime types can be filed with an officer or PSS, however
                  online is recommended as it is the only way you can have an
                  instant copy of the report for your personal records or to
                  provide to your bank or insurance company.
                </v-card-text>
              </v-col>

              <!-- 2nd col -->
              <v-col cols="12" class="col-lg-6 py-0">
                <v-card-title class="py-0 pb-lg-3">
                  Do I have to file a police report?
                </v-card-title>
                <v-card-text>
                  No, choosing to file a report is a choice only the victim of
                  the crime can make. It may be recommended by your insurance,
                  attorney, or even employer, however it is your right as a
                  victim to not file a report. In Nevada, information exchange
                  traffic accidents are not investigated by law enforcement and
                  do not need to be documented.
                </v-card-text>
              </v-col>
            </v-row>
          </v-col>
        </v-card>

        <!-- tips for filing -->
        <a
          id="filingtips_link"
          name="filingtips_link"
          href="filingtips_link"
        ></a>
        <v-row id="filingtips" col="12" class="mt-0 mb-4">
          <v-col col="12">
            <v-card class="mt-0">
              <v-card-title class="title-text">
                Tips for Filing Your Report
                <v-card-text class="card-text-tips" card-text-tips>
                  <ul>
                    <li>
                      In the narrative, please provide as much information as
                      possible regarding what happened and any relevant details
                      of the crime.
                    </li>
                    <li>
                      For any kind of financial crime/fraudulent transactions,
                      please be sure to include the specific date, time, dollar
                      amount, and location of each transaction. Depending on
                      this information, we may be able to request video
                      surveillance from businesses.
                    </li>
                    <li>
                      If you have photo/video surveillance that you were unable
                      to upload into the report, please state that in the
                      narrative of your report and a Police Services Specialist
                      will issue you a link to upload any
                      photos/videos/documents into our secure online server,
                      Axon.
                    </li>
                  </ul>
                </v-card-text>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .topbar {
    height: 18px;
    background-color: #708e92;
  }

  #cardYouTube {
    vertical-align: middle;
    text-align: center;
  }

  /* ratio - .67 */
  #cardYouTube iframe {
    width: 320px;
    height: 215px;
  }
  .howtotext {
    margin: 0 auto;
  }

  .title-text,
  .card-text-tips {
    word-break: normal;
  }

  .toc-links {
    width: 100%;
  }

  .toc-links a {
    width: 100%;
    color: #039be5;
    text-transform: uppercase;
  }

  .help-text {
    font-weight: 400;
    font-size: 75%;
    line-height: 1.2rem;
  }

  .img-text {
    width: 100%;
    flex-wrap: wrap;
  }

  .img-text img {
    width: 100%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .img-text img {
    width: 100%;
  }

  #cardYouTube iframe {
    padding-top: 20px;
    padding-bottom: 20px;
    width: 551px;
    height: 372px;
  }
}

/* ipad landscape */

@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .lg-top-row {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;
  }
  .set-vcard-height {
    height: 320px;
  }

  .img-text img {
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  #cardYouTube iframe {
    width: 725px;
    height: 470px;
  }
  .lg-top-row {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;
  }

  .set-vcard-height {
    height: 300px;
  }

  .img-text img {
    width: 100%;
  }

  .lg-text-width {
    width: 85%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "frontdeskcards",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
